import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ChartLoader from '../../Loaders/ChartLoader';
import { chartBlue, chartRed, chartYellow } from '../../../shared/config';
import Auth from '../../../shared/Auth';
import CustomLineChart from '../../Custom/CustomLineChart';
import axios from '../../../utils/axiosClient';

class AccumulatedEnergy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialize: true,
      options: {},
      width: 0,
    };
    this.chart = null;
  }

  componentDidMount() {
    this.fetchData(this.props.assetId, 1);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.assetId, nextProps.assetId)) {
      this.fetchData(nextProps.assetId, 1);
    }
  }

  async fetchData(assetId, noOfMonths) {
    // noOfMonths = 1 or 0 1 - 1month,0 - 6month
    this.setState({ initialize: true });
    const checkToken = await Auth();
    if (checkToken) {
      const url = `report/accumulatedenergybyassetid/${assetId}/${noOfMonths}`;
      axios
        .get(url)
        .then((response) => {
          if (response.data.statusCode === 200) {
            this.drawChart(response.data.result, assetId, noOfMonths);
          } else {
            this.drawChart([], assetId, noOfMonths);
          }
        })
        .catch((error) => {
          console.log(error);
          this.drawChart([], assetId, noOfMonths);
        });
    }
  }

  drawChart(data, assetId, noOfMonths) {
    const accuenergyR = [];
    const accuenergyY = [];
    const accuenergyB = [];
    let unit = '';

    if (data.length > 0) {
      unit = data[0][0].EnergyUnit;
      data[1].forEach(async (element) => {
        const tmstmp = Date.parse(element.RptDate.replace('T', ' '));
        accuenergyR.push([tmstmp, parseFloat(element.AEnergy_R)]);
        accuenergyY.push([tmstmp, parseFloat(element.AEnergy_Y)]);
        accuenergyB.push([tmstmp, parseFloat(element.AEnergy_B)]);
      });
    }
    const self = this;

    const obj = {
      type: 'column',
      width: document.getElementById('chrt-accumulatedEnrgy').clientWidth,
      title: 'Accumulated Energy',
      unit: `Accumulated Energy (${unit})`,
      selected: noOfMonths === 1 ? 0 : 3,
      series: [
        {
          name: 'Accuenergy_R',
          dataGrouping: {
            units: [
              [
                'day', // unit name
                [1], // allowed multiples
              ],
            ],
          },
          color: chartRed,
          data: accuenergyR,
        },
        {
          name: 'Accuenergy_Y',
          dataGrouping: {
            units: [
              [
                'day', // unit name
                [1], // allowed multiples
              ],
            ],
          },
          color: chartYellow,
          data: accuenergyY,
        },
        {
          name: 'Accuenergy_B',
          dataGrouping: {
            units: [
              [
                'day', // unit name
                [1], // allowed multiples
              ],
            ],
          },
          color: chartBlue,
          data: accuenergyB,
        },
      ],
      evnt: () => self.fetchData(assetId, 6),
    };
    this.setState({
      options: obj,
      initialize: false,
    });
  }

  render() {
    const { options, initialize } = this.state;
    return (
      <div>
        {initialize ? (
          <ChartLoader height="150" width="600" />
        ) : (
          <CustomLineChart options={options} />
        )}
      </div>
    );
  }
}

AccumulatedEnergy.propTypes = {
  assetId: PropTypes.number.isRequired,
};
export default AccumulatedEnergy;
